import { render, staticRenderFns } from "./UcPdfUse.vue?vue&type=template&id=4c156e89&scoped=true&"
import script from "./UcPdfUse.vue?vue&type=script&lang=js&"
export * from "./UcPdfUse.vue?vue&type=script&lang=js&"
import style0 from "./UcPdfUse.vue?vue&type=style&index=0&id=4c156e89&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c156e89",
  null
  
)

export default component.exports